<section
	class="plc-toggle-button__option"
	*ngFor="let option of options"
	[class]="cellClass(option.id)"
	(click)="handleOptionClick(option.id)"
>
	<plc-avatar [src]="option.avatarUrl" [shape]="'circle'" />
	<plc-avatar [src]="option.avatarUrl2" [shape]="'circle'" />
</section>
